// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import ErrorImageJira from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/error';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages';

type Props = {
	description: string;
	actionDescription: string;
	onClick: () => void;
	intl: IntlShape;
};

type State = {
	actionFired: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
class GlobalError extends PureComponent<Props, State> {
	static defaultProps: Partial<Props> = {
		description: 'We encountered a problem. Please try again later.',
		actionDescription: 'Retry',
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	constructor(props: any) {
		super(props);
		this.state = { actionFired: false };
	}

	onClick = () => {
		this.setState({ actionFired: true });
		this.props.onClick();
	};

	render() {
		const {
			actionDescription,
			description,
			onClick,
			intl: { formatMessage },
		} = this.props;
		return (
			<EmptyState
				size="wide"
				renderImage={getAkEmptyStateRenderImageFn(ErrorImageJira)}
				maxImageWidth={120}
				header={formatMessage(messages.header)}
				isLoading={this.state.actionFired}
				description={description}
				primaryAction={
					// @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?
					actionDescription && onClick ? (
						<Button appearance="primary" isDisabled={this.state.actionFired} onClick={this.onClick}>
							{actionDescription}
						</Button>
					) : undefined
				}
			/>
		);
	}
}

export default injectIntl(GlobalError);
